import { TimeFrameKey } from "data/time-frames";

export const getRelativeTimeframeLabel = (timeframe: TimeFrameKey) => {
  switch (timeframe) {
    case "7d":
      return 'this week';
    case "1m":
      return 'this month';
    case "3m":
      return 'the last 3 months';
    case "1y":
      return 'the last year';
    case "all":
      return 'over all time';
    case "24h":
    default:
      return 'today';
  }
};

